export const TrustedDollarIcon = () => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#E6F2E8" />
      <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F4F9F4" strokeWidth="8" />
      <path
        d="M24.9842 37H32.0102C32.6404 37 33.2616 36.8511 33.8233 36.5654C34.385 36.2798 34.8713 35.8654 35.2425 35.3562C35.6137 34.847 35.8593 34.2573 35.9594 33.6351C36.0594 33.0129 36.0111 32.3759 35.8182 31.776L34.1122 26.47C33.7883 25.4622 33.1529 24.5832 32.2975 23.9596C31.4421 23.336 30.4108 23 29.3522 23H27.6422C26.5837 23 25.5524 23.336 24.697 23.9596C23.8416 24.5832 23.2062 25.4622 22.8822 26.47L21.1762 31.776C20.9834 32.3759 20.9351 33.0129 21.0351 33.6351C21.1352 34.2573 21.3808 34.847 21.752 35.3562C22.1232 35.8654 22.6095 36.2798 23.1712 36.5654C23.7329 36.8511 24.3541 37 24.9842 37ZM31.4972 19C30.8306 21.6667 29.8306 23 28.4972 23C27.1639 23 26.1639 21.6667 25.4972 19H31.4972Z"
        stroke="url(#paint0_linear_1_27077)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5 27H28C27.6022 27 27.2206 27.158 26.9393 27.4393C26.658 27.7206 26.5 28.1022 26.5 28.5C26.5 28.8978 26.658 29.2794 26.9393 29.5607C27.2206 29.842 27.6022 30 28 30H29C29.3978 30 29.7794 30.158 30.0607 30.4393C30.342 30.7206 30.5 31.1022 30.5 31.5C30.5 31.8978 30.342 32.2794 30.0607 32.5607C29.7794 32.842 29.3978 33 29 33H26.5M28.5 26V27M28.5 33V34"
        stroke="url(#paint1_linear_1_27077)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_27077"
          x1="28.4972"
          y1="19"
          x2="28.4972"
          y2="37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#119822" />
          <stop offset="1" stopColor="#06320B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_27077"
          x1="28.5"
          y1="26"
          x2="28.5"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#119822" />
          <stop offset="1" stopColor="#06320B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
